// extracted by mini-css-extract-plugin
export default {"logo_wrapper":"NotFoundPage_logo_wrapper__5QhF1","spinner":"NotFoundPage_spinner__8YUcu"};